import Breadcrumbs from "../Breadcrumbs";
const Topbar = () => {
    return (
        <div >
            
                <h1 className="text-3xl text-slate-500">User Profile</h1>
                <div className="flex flex-row justify-between">
                <Breadcrumbs page="Profile" />
                <button className="bg-orange-500 hover:bg-orange-700 text-white font-bold py-2 px-4 rounded-xl">Edit</button>
            </div>
            
        </div>
    )
}

export default Topbar;